import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'wouter';
import { ScopieLogo } from '@/components/brand/ScopieLogo';
import { LEGAL_ENTITY_NAME, LEGAL_PLACE } from '@/config/legal-entity';
import { FUNNEL_COPY } from '@/marketing/funnel-copy';
import '@/pages/landing/home/home.css';
import './marketing.css';

// Archivo, the typeface of the landing, like LandingLayout.
const ARCHIVO_CSS = 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;600;700;800;900&display=swap';

/**
 * The shell of an ad landing page: the landing's own style scope (`.cc-home`), a header with the logo only and a footer with the terms and the privacy
 * policy only. No navigation, language menu or sign-in: the one way on is the page's own call to action.
 */
export function FunnelLayout({ children }: { children: ReactNode }) {
  return (
    <div className="cc-home mk">
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link rel="stylesheet" href={ARCHIVO_CSS} />
      </Helmet>
      <header className="hn">
        <div className="wrap">
          <a className="logo" href="/" aria-label="Scopie home">
            <ScopieLogo />
          </a>
        </div>
      </header>
      <main className="mk-main">{children}</main>
      <footer className="hf">
        <div className="wrap">
          <ul className="flex gap-6">
            <li><Link href="/terms">{FUNNEL_COPY.footer.terms}</Link></li>
            <li><Link href="/privacy">{FUNNEL_COPY.footer.privacy}</Link></li>
          </ul>
          <small>© {new Date().getFullYear()} {LEGAL_ENTITY_NAME} · {LEGAL_PLACE}</small>
        </div>
      </footer>
    </div>
  );
}
